(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    /* Submits the filter form in the background and swaps in fresh results.
     Falls back to a normal form submit if anything goes wrong. */
  class FacetFilters extends HTMLElement {
    /* Listeners live on the element, not on the form. Applying a filter swaps
       this element's innerHTML, which throws away the form node — and with it
       any listener bound to it. Bound that way, the first filter works and every
       one after it silently does nothing: the box you ticked looks ticked
       because the browser ticked it, while the counts still describe the last
       request that actually ran. */
    connectedCallback() {
      this.addEventListener('change', (event) => {
        if (event.target.closest('[data-facet-form]')) this.apply();
      });

      this.addEventListener('submit', (event) => {
        if (!event.target.closest('[data-facet-form]')) return;
        event.preventDefault();
        this.apply();
      });
    }

    get form() {
      return this.querySelector('[data-facet-form]');
    }

    async apply() {
      const form = this.form;
      if (!form) return;

      /* Rebuilt rather than pruned: params.delete(key) removes every entry
         sharing that key, so deleting one empty field would take the filled
         values next to it. */
      const params = new URLSearchParams();
      for (const [key, value] of new FormData(form).entries()) {
        if (value !== '') params.append(key, value);
      }

      const query = params.toString();
      const base = window.location.pathname;

      try {
        const response = await fetch(`${base}?${query}&section_id=${this.dataset.section}`);
        if (!response.ok) throw new Error(response.statusText);

        const markup = await response.text();
        const parsed = new DOMParser().parseFromString(markup, 'text/html');

        /* Which dropdowns were open, so a filter click does not slam the panel
           shut and make the shopper reopen it for every value they tick. */
        const opened = Array.from(this.querySelectorAll('[data-dropdown][open]'))
          .map((node) => node.querySelector('.facets__summary')?.textContent.trim());

        ['facet-filters', '[data-collection-results]'].forEach((selector) => {
          const fresh = parsed.querySelector(selector);
          const current = document.querySelector(selector);
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        });

        this.querySelectorAll('[data-dropdown]').forEach((node) => {
          const label = node.querySelector('.facets__summary')?.textContent.trim();
          if (label && opened.includes(label)) node.open = true;
        });

        window.history.replaceState({}, '', query ? `${base}?${query}` : base);
      } catch (error) {
        form.submit();
      }
    }
  }

  if (!customElements.get('facet-filters')) {
    customElements.define('facet-filters', FacetFilters);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["localization-form"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-localization-select]').forEach((select) => {
    select.addEventListener('change', () => select.form.submit());
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    /* Tabbed gallery. Arrow keys move between thumbnails, matching the tablist
     pattern; Home and End jump to the ends. */
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      if (!this.tabs.length) return;

      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (tab) this.select(tab);
      });

      this.addEventListener('keydown', (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (!tab) return;

        const index = this.tabs.indexOf(tab);
        let next = null;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = index + 1;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = index - 1;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else return;

        event.preventDefault();
        const target = this.tabs[(next + this.tabs.length) % this.tabs.length];
        this.select(target);
        target.focus();
      });

      // The variant picker asks the gallery to show a specific media item.
      this.addEventListener('gallery:show', (event) => {
        const tab = this.tabs.find((t) => t.dataset.mediaId === String(event.detail.mediaId));
        if (tab) this.select(tab);
      });
    }

    select(tab) {
      this.tabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;

        const panel = document.getElementById(item.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
    }
  }

  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    /* Matches the selected option values against the product's variants, updates
     the URL, and asks the server for fresh markup so price, availability and
     buttons all stay truthful. */
  class VariantPicker extends HTMLElement {
    connectedCallback() {
      const data = this.querySelector('[data-variant-data]');
      this.variants = data ? JSON.parse(data.textContent) : [];

      this.addEventListener('change', () => this.onChange());
    }

    get selectedValues() {
      return Array.from(this.querySelectorAll('.variant-picker__input:checked'))
        .sort((a, b) => a.dataset.optionPosition - b.dataset.optionPosition)
        .map((input) => input.value);
    }

    onChange() {
      const values = this.selectedValues;

      const variant = this.variants.find((candidate) =>
        candidate.options.length === values.length &&
        candidate.options.every((option, index) => option === values[index])
      );

      // Keep each option's readout in step even before the fetch returns.
      this.querySelectorAll('.variant-picker__input:checked').forEach((input) => {
        const name = input.name.split('-')[0];
        const readout = this.querySelector(`[data-selected-for="${name}"]`);
        if (readout) readout.textContent = input.value;
      });

      if (!variant) return;

      /* The radios are named for their option, not in a form Shopify parses, so
         the hidden id field is the only thing that decides which variant is
         added. Setting it here rather than waiting for the fetch means a slow or
         failed request can never leave the shopper adding the variant they were
         looking at before. */
      const idField = this.closest('form')?.querySelector('input[name="id"][data-variant-id]');
      if (idField) {
        idField.value = variant.id;
        idField.disabled = !variant.available;
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      if (variant.featured_media) {
        document.querySelector('product-gallery')?.dispatchEvent(
          new CustomEvent('gallery:show', { detail: { mediaId: variant.featured_media.id } })
        );
      }

      this.refresh(variant);
    }

    async refresh(variant) {
      const section = this.dataset.section;
      const url = `${this.dataset.url}?variant=${variant.id}&section_id=${section}`;

      try {
        const response = await fetch(url);
        if (!response.ok) return;

        const markup = await response.text();
        const parsed = new DOMParser().parseFromString(markup, 'text/html');

        ['[data-product-price]', '[data-product-buy]', '[data-product-inventory]', '[data-product-shipping]'].forEach((selector) => {
          const fresh = parsed.querySelector(selector);
          const current = document.querySelector(selector);
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        });
      } catch (error) {
        // The form still posts the right variant id; only the preview is stale.
      }
    }
  }

  if (!customElements.get('variant-picker')) {
    customElements.define('variant-picker', VariantPicker);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-panel"] && !Shopify.designMode) return;
  try {
    /* Predictive search. Fetches Shopify's native predictive endpoint, rendered
     by snippets/predictive-results.liquid through a section render.
     Results are announced politely; focus stays in the input so typing is
     never interrupted. */
  (() => {
    const form = document.querySelector('[data-predictive-search]');
    if (!form) return;

    const input = form.querySelector('input[name="q"]');
    const output = document.getElementById('predictive-results');
    if (!input || !output) return;

    let controller = null;
    let timer = null;

    const clear = () => {
      output.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
    };

    const run = async (term) => {
      if (controller) controller.abort();
      controller = new AbortController();

      const params = new URLSearchParams({
        q: term,
        'resources[type]': 'product,article,page',
        'resources[limit]': '5',
        'resources[options][unavailable_products]': 'last',
        section_id: 'predictive-search',
      });

      try {
        const response = await fetch(
          `${window.Shopify.routes.root}search/suggest?${params}`,
          { signal: controller.signal }
        );
        if (!response.ok) throw new Error(response.statusText);

        const markup = await response.text();
        const parsed = new DOMParser().parseFromString(markup, 'text/html');
        const results = parsed.querySelector('[data-predictive-output]');

        output.innerHTML = results ? results.innerHTML : '';
        input.setAttribute('aria-expanded', output.children.length ? 'true' : 'false');

        const region = document.getElementById('live-region');
        if (region) {
          const count = output.querySelectorAll('.search-panel__item').length;
          region.textContent = output.dataset.announcement || String(count);
        }
      } catch (error) {
        if (error.name !== 'AbortError') clear();
      }
    };

    input.addEventListener('input', () => {
      const term = input.value.trim();
      clearTimeout(timer);

      if (term.length < 2) {
        clear();
        return;
      }

      timer = setTimeout(() => run(term), 250);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
